import React, { useEffect, useState } from "react";

import "./listCard.scss";
import { IonCol } from "@ionic/react";
import { Link } from "react-router-dom";
import { utilService } from "../../../services";
import { setFavSiteListService } from "./listCard.service";
import { siteListResultInterface } from "../../../pages/Sites/sites.model";
import Call from "../Call/call";

interface FavoriteRequest {
  Reg_code: string;
  siteId: string;
  fav: boolean;
  unitId?: number;
}

const ListCardComponent = ({
  listData,
  componentName,
  setParentListData,
  parentSource,
}: any) => {
  const [favorite, setFavoriteIcon] = useState(false);

  useEffect(() => {
    setFavoriteIcon(listData.fav);
  }, []);

  const setFavorite = (listData: any) => {
    setFavoriteIcon((value) => !value);

    const params: FavoriteRequest = {
      Reg_code: utilService.getNetwork(),
      siteId: listData.id,
      fav: !favorite,
    };
    let apiResponse: Promise<
      siteListResultInterface 
    >;
    if (parentSource !== "sites") {
      params.unitId = listData.id;
      params.siteId = listData.site.toString();
      apiResponse = setFavSiteListService.setFavorite(false, params);
    } else {
      apiResponse = setFavSiteListService.setFavorite(true, params);
    }
    apiResponse.then((res: any) => {
      if (res.isSuccess) {
        if (parentSource === "sites") {
          setParentListData(res.siteListResult);
        } else {
          setParentListData(
            parentSource === "units" ? res.unitListResult : res.deptListResult
          );
        }
      }
    });
  };

  const setDataToCall = () => {
    return {
      callTo: parentSource,
      contactNumber: listData?.contactDetails?.[0]?.number ?? "",
      name: listData.name,
    };
  };


  return (
    <IonCol className="base-column" size="12" size-lg="3">
      <div
        className={
          listData.isAssigned !== false
            ? "list-card"
            : "list-card disabled-card"
        }
      >
        <div
          className={`content-wrapper ${
            parentSource === "departments" ? "disabled-card" : "next-card"
          }`}
        >
          <Link
            to={{
              pathname: `/client/${listData.id}/${componentName}/`,
              state: {
                siteName: listData.name,
              },
            }}
          >
            <div className="input-data">
              <div className="item-title large-font" title={listData.name}>
                {listData.name}
              </div>
              <div
                className="item-sub-title small-font"
                title={listData.location}
              >
                {listData.location}
              </div>
            </div>
          </Link>
        </div>
      </div>
      <div
        className={
          listData.isAssigned !== false
            ? "fav-button"
            : "fav-button disabled-card"
        }
      >
        <div
          className={
            favorite !== false
              ? "input-icon icon-favorite_fill"
              : "input-icon icon-favorite"
          }
          onClick={() => setFavorite(listData)}
        ></div>
      </div>

      <div
        className={
          listData.isAssigned !== false
            ? "call-button"
            : "call-button disabled-card"
        }
      >
        <Call
          selectedDoctorGuid=""
          dataFromParent={setDataToCall()}
          isAssignedNumber={true}
        ></Call>
      </div>
    </IonCol>
  );
};

export default ListCardComponent;
